import { getFunctions, httpsCallable } from "firebase/functions";
import { v4 as uuidv4 } from "uuid";
import { getGeoData } from "./getGeo";
import { FIREBASE_COLLECTIONS } from "@/lib/constants";

const VISITOR_ID_KEY = 'qwiku_visitor_id';

export async function trackEvent(cardId: string, eventType: 'visit' | 'download' | 'contact_scanned' | 'contact_received' | 'contact_shared', extra: any = {}, companyId?: string) {
    try {
        const functions = getFunctions();
        const trackShardedAnalytics = httpsCallable(functions, "trackShardedAnalytics");

        const storedVisitorId = localStorage.getItem(VISITOR_ID_KEY);
        const visitorId = storedVisitorId || uuidv4();
        if (!storedVisitorId) {
            localStorage.setItem(VISITOR_ID_KEY, visitorId);
        }

        const geo = await getGeoData();

        await trackShardedAnalytics({
            cardId,
            companyId,
            collectionName: FIREBASE_COLLECTIONS.ANALYTICS,
            eventType,
            visitorId,
            geo,
            ...extra
        });
    } catch (error) {
        console.error('Analytics error:', error);
    }
}
